export const ADD_SOURCES = 'addSources'
export const SEND_GA_EVENT = 'sendGAEvent'

export const exportImportFieldMapping = {
  name: 'Name',
  identifier: 'Url or @',
  type: 'Type',
  category: 'Category',
  sub_category: 'Sub Category',
}
